import React from "react";
import styled from "styled-components";
import { vendorTaglineOf } from "../utils/vendorTagline";

/**
 * The vendor's tagline under its name, on every card and storefront header
 * (restaurants, shops/wholesalers, pharmacies, brands). Renders nothing at all
 * when the vendor has not written one (see utils/vendorTagline.js).
 *
 * Restyle per surface with styled(VendorTagline)`...`; `lines` caps how many
 * lines a card gives it before the ellipsis (the full text is in the title).
 */
const VendorTagline = ({ vendor, lines = 2, className }) => {
  const text = vendorTaglineOf(vendor);
  if (!text) return null;
  return (
    <Line className={className} $lines={lines} title={text}>
      {text}
    </Line>
  );
};

export default VendorTagline;

const Line = styled.p`
  margin: 0;
  font-size: 0.82rem;
  font-weight: 400;
  line-height: 1.4;
  color: #475569;
  text-align: left;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-line-clamp: ${({ $lines }) => $lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
